import { Button } from '../../cdl/Button/Button';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { IconPlus } from '../../common/icons/cdl/Plus';
import { Box } from '../../common/ui/Box';

import { SsoBanner } from './SsoBanner';

interface SsoEmptyStateBannerProps {
    onAddConnection: () => void;
}

export const SsoEmptyStateBanner = ({ onAddConnection }: SsoEmptyStateBannerProps) => {
    return (
        <SsoBanner>
            <Text variant="subtitle1" as="h2">
                {translate('sso.emptyState.headline')}
            </Text>
            <Text variant="body" color="foreground.subtle">
                {translate('sso.emptyState.description')}
            </Text>
            <Box>
                <Button emphasis="high" LeadingIcon={IconPlus} onClick={onAddConnection}>
                    {translate('sso.addConnectionId')}
                </Button>
            </Box>
        </SsoBanner>
    );
};
